// const memoized = new Map()
// export function compute<T>(...args: T) {

//   // a hack
//   const key = JSON.stringify({ ...args })

//   if (memoized.has(key)) {
//     return memoized.get(key)
//   }
//   else {
//     const value = peformSlowComputation(...args)
//     memoized[key] = value
//     return value
//   }
// }

type CalcKeyFn = (object: any) => string;
export const calcKeyJson: CalcKeyFn = (object) => {
  const key = JSON.stringify(object, Object.keys(object).sort());
  return key;
}

const memoizedByKey = new Map()
export function intern<T>(object: T, calcKey: CalcKeyFn = calcKeyJson): T {
  if (!object)
    return object;

  const key = calcKey(object);

  const cached = memoizedByKey.get(key);
  if (cached) {
    return cached;
  }

  const freezed = Object.freeze(object);
  memoizedByKey.set(key, freezed);
  return freezed;
}